import { $CommercePlatform } from "./main";

window.sps.Utils = window['sps']['Util'] || {};
$CommercePlatform.init().catch((e) => {
    console.error("Error initializing Commerce Platform", e);
});
